<sabis-ngx-checkbox id="text"
                    [(ngModel)]="record[column.field]"
                    [required]="column.validation?.isRequired === true"></sabis-ngx-checkbox>
